var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLightChevroninline = function SvgLightChevroninline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 34,
    fill: "none",
    className: "light-chevron_inline_svg__text-gray-40 light-chevron_inline_svg__mt-1 light-chevron_inline_svg__h-auto light-chevron_inline_svg__w-2 light-chevron_inline_svg__shrink-0 light-chevron_inline_svg__transition-[transform,color] light-chevron_inline_svg__duration-200 light-chevron_inline_svg__group-hover:text-black light-chevron_inline_svg__rotate-90",
    viewBox: "0 0 19 34"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 2,
    d: "m1 1 16 16L1 33"
  })));
};
export default SvgLightChevroninline;